import React from 'react';
import { Link } from 'react-router-dom';


const TryBeforeYouBuy: React.FC = () => {
    return (
        <section className="relative overflow-hidden bg-gradient-to-b from-white to-[#eeebfd] pt-20 pb-44 text-center px-4">
            {/* Green Tag */}
            <span className="inline-block bg-[#e0f8de] text-[#0a6c67] font-semibold text-xs px-4 py-1 rounded-full tracking-wide mb-4">
                Let’s get started

            </span>

            {/* Main Heading */}
            <h2 className="text-4xl md:text-5xl font-bold text-[#0f0a33] mb-4">
                Transform your business with <br /> Minterminds?
            </h2>

            {/* Subtext */}
            <p className="text-gray-600 max-w-xl mx-auto text-base md:text-lg">
                Contact Minterminds now to explore how our solutions can drive your business forward. Don’t miss out—get in touch!
            </p>

            {/* CTA Button */}
            <div className="mt-8 mb-16">
                <Link
                    to="/contact"
                    className="border-2 border-[#398ffc] text-[#398ffc] px-6 py-3 rounded-xl hover:bg-blue-50 transition flex flex-col items-center w-fit mx-auto">
                    <span className="font-bold text-xl">Contact now</span>
                    {/* <span className="text-sm text-blue-500 font-semibold">No Commitments - Preview Before You Buy</span> */}
                </Link>
            </div>

            {/* Support Cards */}
            <div className="flex flex-col md:flex-row justify-center items-center gap-6">
                {/* Card 1 */}
                <div className="bg-white shadow-lg rounded-xl p-8 w-full md:w-[350px] text-left flex items-start space-x-4">
                    <img src="/faq1.webp" alt="" />          <div>
                        <h4 className="text-lg font-semibold text-[#0f0a33]">Knowledge Base &<br />Documentation</h4>
                    </div>
                </div>

                {/* Card 2 */}
                <div className="bg-white shadow-md rounded-xl p-8 w-full md:w-[350px] text-left flex items-start space-x-4">
                    <img src="/faq2.webp" alt="" />                    <div>
                        <h4 className="text-lg font-semibold text-[#0f0a33]">Email Support</h4>
                        <p className="text-gray-600 text-sm">info@minterminds.com</p>
                    </div>
                </div>

                {/* Card 3 */}
                <div className="bg-white shadow-md rounded-xl p-8 w-full md:w-[350px] text-left flex items-start space-x-4">
                    <img src="/faq3.webp" alt="" />          <div>
                        <h4 className="text-lg font-semibold text-[#0f0a33]">Customer Support</h4>
                        <p className="text-gray-600 text-sm">+63 975 857 8476</p>
                    </div>
                </div>
            </div>

            {/* Curved Background Mask (SVG) */}
            <div className="absolute bottom-0 left-0 w-full pointer-events-none z-0">
                <svg viewBox="0 0 1440 320" className="w-full h-[180px]" preserveAspectRatio="none">
                    <path
                        fill="#648ffc"
                        fillOpacity="1"
                        d="M0,192L60,176C120,160,240,128,360,138.7C480,149,600,203,720,208C840,213,960,171,1080,144C1200,117,1320,107,1380,101.3L1440,96V320H0Z"
                    ></path>
                </svg>
            </div>


        </section>
    );
};

export default TryBeforeYouBuy;
